import React from "react";

import "./styles.css";

const Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 7.5C6.5 7.76522 6.60536 8.01957 6.79289 8.20711C6.98043 8.39464 7.23478 8.5 7.5 8.5C7.76522 8.5 8.01957 8.39464 8.20711 8.20711C8.39464 8.01957 8.5 7.76522 8.5 7.5C8.5 7.23478 8.39464 6.98043 8.20711 6.79289C8.01957 6.60536 7.76522 6.5 7.5 6.5C7.23478 6.5 6.98043 6.60536 6.79289 6.79289C6.60536 6.98043 6.5 7.23478 6.5 7.5Z"
      stroke="#043B3B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 6V11.172C3.00011 11.7024 3.2109 12.211 3.586 12.586L11.296 20.296C11.748 20.7479 12.3609 21.0017 13 21.0017C13.6391 21.0017 14.252 20.7479 14.704 20.296L20.296 14.704C20.7479 14.252 21.0017 13.6391 21.0017 13C21.0017 12.3609 20.7479 11.748 20.296 11.296L12.586 3.586C12.211 3.2109 11.7024 3.00011 11.172 3H6C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6Z"
      stroke="#043B3B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 13.847L11 15L11.532 13.143L10 12H11.902L12.5 10.2L13.098 12H15L13.468 13.143L14 15L12.5 13.847Z"
      stroke="#043B3B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SubscriptionTemporaryDiscountBadge = (props) => {
  const { discount, hasDiscount, hasTemporaryDiscount, temporaryDiscount } =
    props;

  if (hasDiscount && discount) {
    const percent = Math.ceil(discount.value * 100);
    return (
      <div className="subscription-offer-temporary-discount-badge">
        <Icon />
        <p>
          <span>{`${percent}% off`}</span> {` your first month`}
        </p>
      </div>
    );
  }
  if (hasTemporaryDiscount && temporaryDiscount) {
    return (
      <div className="subscription-offer-temporary-discount-badge">
        <Icon />
        <p>
          <span>{`£${temporaryDiscount} off`}</span> {` your first month`}
        </p>
      </div>
    );
  }
  return null;
};

export default SubscriptionTemporaryDiscountBadge;
